import React from 'react'
import { LRX_41202_UC_IN_MARK_ALL_ITEM_FULFILLMENT } from '../../../../../../../constants'
import { getFeatureFromCache } from '../../../../../../../util/feature-cache'
import {
  OutletToFulfilFrom,
  OutletToFulfilFromProps,
} from './OutletToFulfilFrom'
import { OutletToFulfilFromLegacy } from './OutletToFulfilFromLegacy'

export const OutletToFulfilFromWrapper: React.FC<OutletToFulfilFromProps> = props => {
  const isUnifiedMarkAllItemFulfillmentEnabled = getFeatureFromCache(
    LRX_41202_UC_IN_MARK_ALL_ITEM_FULFILLMENT
  )

  return isUnifiedMarkAllItemFulfillmentEnabled ? (
    <OutletToFulfilFrom {...props} />
  ) : (
    <OutletToFulfilFromLegacy {...props} />
  )
}

export { OutletToFulfilFromWrapper as OutletToFulfilFrom }
export type { OutletToFulfilFromProps }
